module.exports = __webpack_public_path__ + "img/enoughFundsMasterCard.b10c48bb.png";